import jqRequest from '../jqRequest'
import linkUrls from '../urls/link'

export default {
  // 获取外链
  getOuterLinkById(data){
    return jqRequest.requestWithToken(linkUrls.getOuterLinkById, data);
  },
}